<template>
<div id="precartaporte">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="library_books" title="Borradores Carta Porte" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer />

            <UploadExcel title="Importar Layout" idInput="articulosKey" :on-success="handleSuccess" :before-upload="beforeUpload" :firstRow="2" />
          </v-card-actions>
          <v-card-text>
            <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()">
              <v-client-table ref="vuetable" :data="items.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                </template>
                <template slot="estatus" slot-scope="props">
                  <span v-if="props.row.estatus == 0">Creado</span>
                  <span v-else>Indefinido</span>
                </template>
                <template slot="fecha" slot-scope="props">
                  {{props.row.fecha.replace("T", " ").substring(0,16)}}
                </template>
                <template slot="actions" slot-scope="props">
                  <div class="" style="text-align:left">
                    <v-btn x-small fab dark color="red" @click.native="eliminar(props.row.uuid)" title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>&nbsp;
                    <v-btn v-if="props.row.tipo=='Web'?true:false" x-small fab dark color="blue" @click.native="editar(props.row.uuid)" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-client-table>
              <template>
                <div v-if="pwPagination.total > 0">
                  <div class="mt-3">
                    <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="items" :options="pwPagination.options"></PaginacionComponent>
                  </div>
                </div>
              </template>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import UploadExcel from '@/components/UploadExcel/UploadExcel.vue';
import moment from "moment";
import PaginacionComponent from '@/components/PaginacionComponent.vue';

export default {
  components: {
    "UploadExcel": UploadExcel,
    "PaginacionComponent": PaginacionComponent
  },

  name: "DashboardDataTables",
  created: function() {
    this.URL = this.$hostname + "carta_porte/";
    this.model = this.clean_model();
    this.cargar();

    this.pwPagination.links.url = this.URL + "list_pre_carta_porte/";
    this.pwPagination.options.filters.uuid_empresa = this.model.uuid_empresa;
  },
  mounted: function() {
    this.model_filters = this.$refs.vuetable.query;
  },
  watch: {
    model_filters: {
      handler(val) {
        let filtros = {};

        if (this.model_filters["receptor.rfc"]) {
          filtros["receptor.rfc"] = { '$regex': this.model_filters["receptor.rfc"], '$options': 'i' };
        }
        if (this.model_filters["destino.descripcion"]) {
          filtros["destino.descripcion"] = { '$regex': this.model_filters["destino.descripcion"], '$options': 'i' };
        }
        if (this.model_filters['TipoDeComprobante']) {
          filtros["TipoDeComprobante"] = this.model_filters['TipoDeComprobante'];
        }
        if (this.model_filters["fecha"]) {
          filtros["fecha"] = { '$regex': this.model_filters["fecha"], '$options': 'i' };
        }
        if (this.model_filters["tipo"]) {
          filtros["tipo"] = { '$regex': this.model_filters["tipo"], '$options': 'i' };
        }

        this.pwPagination.options.filters = {
          filtros: filtros,
          uuid_empresa: this.model.uuid_empresa
        }
      },
      deep: true
    }
  },
  data: () => ({
    tabla: "pre_carta_porte",
    modal: false,
    model_filters: "",
    pwPagination: {
      total: 0,
      links: {
        url: '',
        next: '',
        prev: '',
      },
      options: {
        tipo: 1,
        size: 10,
        filters: {}
      }
    },
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home",
      },
      {
        text: "Borradores Carta Porte",
        disabled: true,
        href: "",
      },
    ],
    model: {},
    updateModel: false,
    columns: ["fecha", "receptor.rfc", "destino.descripcion", "TipoDeComprobante", "tipo", "actions"],
    options: {
      filterable: ["receptor.rfc", "destino.descripcion", "tipo", "TipoDeComprobante", "fecha"],
      headings: {
        fecha: "Fecha",
        "receptor.rfc": "RFC Receptor",
        "destino.descripcion": "Destino",
        TipoDeComprobante: "Tipo Comprobante",
        tipo: "Origen Información",
        actions: "Operaciones"
      }
    },
    items: {items:[]},
    search: undefined,
    URL: ""

  }),
  methods: {
    cargar: function() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var params = {
        "uuid_empresa": this.model.uuid_empresa
      }

      var self = this;
      this.$axios.post(this.URL + "list_pre_carta_porte/", params)
        .then(res => {
          self.items.items = res.data.results;
          self.pwPagination.total = res.data.count;
          self.pwPagination.links.next = res.data.next;
          self.pwPagination.links.prev = res.data.previous;
        })
        .catch(err => {
          self.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener los registros.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });
    },
    eliminar: function(id) {
      var self = this;
      self.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show("Espere un momento por favor..");
          var params = {
            uuid: id,
          };
          this.$axios.post(this.URL + "delete_pre_carta_porte/", params)
            .then(res => {
              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se eliminó correctamente.",
                footer: "",
              });
              self.cargar();
            })
            .catch(err => {
              this.$swal({
                type: "error",
                title: "Error",
                text: "Ocurrió un error al eliminar el registro.",
                footer: "",
              });
              console.log(err);
            }).then(() => {
              self.cargar();
              self.$root.$dialogLoader.hide();
            });

        }
      });
    },

    clean_model: function() {
      return {
        uuid: "",
        uuid_empresa: this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa"))),
        clave_remolque: "",
        placas: "",
      };
    },
    editar: function(uuid) {
      this.$local_storage.set(this.$crypto.SHA256("uuid_carta_porte"), this.$crypto.encrypted(uuid));
      this.$router.replace("/newcartaporte");

    },

    handleSuccess: async function({
      results,
      header
    }) {
      var errores = 0;
      var erroresText = '';
      var importData = {};
      try {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var self = this;
        var cartas = [];
        var aux = "";

        // Se Valida que todos los rows tengan los datos obligatorios
        var valido = true;
        results.forEach((item) => {
          var keys = Object.keys(item);
          var requeridos = header.filter(x => x != 'PLACA REMOLQUE 2');
          requeridos.forEach((item2) => {
            if (!keys.includes(item2)) {
              valido = false;
            }
          });

        });

        var carta = {
          productos: []
        };

        if (valido) {
          results.forEach((item, i) => {

            if (aux != item['ID UBICACIÓN ORIGEN'] && i > 0) {
              cartas.push(carta);
              carta = {
                productos: []
              };
            }
            carta.rfc_emisor = item['RFC EMISOR'];
            carta.rfc_receptor = item['RFC RECEPTOR'];
            aux = carta.id_ubicacion_origen = item['ID UBICACIÓN ORIGEN'];
            carta.id_ubicacion_destino = item['ID UBICACIÓN DESTINO'];
            carta.fecha_salida = self.ExcelDateToJSDate(item['FECHA DE SALIDA']);
            carta.hora_salida = self.ExcelTimeToJSDate(item['HORA DE SALIDA']);
            carta.fecha_llegada = self.ExcelDateToJSDate(item['FECHA LLEGADA']);
            carta.hora_llegada = self.ExcelTimeToJSDate(item['HORA LLEGADA']);
            carta.distancia = item['DISTANCIA'];
            carta.rfc_transportista = item['RFC TRANSPORTISTA'];
            carta.placa_vehiculo = item['PLACA VEHICULO'];
            carta.remolque_1 = item['PLACA REMOLQUE 1'];
            carta.remolque_2 = item['PLACA REMOLQUE 2'] != undefined ? item['PLACA REMOLQUE 2'] : null;
            carta.tipo = "Layout";
            carta.fecha_salida = carta.fecha_salida.substring(0, 11) + carta.hora_salida;
            carta.fecha_llegada = carta.fecha_llegada.substring(0, 11) + carta.hora_llegada;
            carta.productos.push({
              "clave_articulo": item['CLAVE ARTICULO'],
              "cantidad": item['CANTIDAD']
            });

            if (i == results.length - 1) {
              cartas.push(carta);
            }
          });
        } else {
          self.$swal({
            type: "error",
            title: "Error",
            text: "Debes llenar correctamente todos los campos obligatorios en el Layout",
            footer: "",
          });
          self.$root.$dialogLoader.hide();
          return;
        }

        if (cartas.length > 0) {
          var params = {
            "pre_carta_porte": []
          }

          cartas.forEach((item, i) => {
            item.uuid = self.$uuid.v4();
            item.estatus = 0;
            item.uuid_empresa = self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("uuid_empresa")));
            item.fecha = moment().format('YYYY-MM-DD HH:mm:ss');

            params.pre_carta_porte.push(item)
          });
          this.$root.$dialogLoader.show("Espere un momento por favor..");
          this.$axios.post(this.URL + "guardar_layout/", params)
            .then(res => {
              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El Layout se cargo correctamente.",
                footer: "",
              });
              self.$root.$dialogLoader.hide();
              self.cargar();

              return;
            })
            .catch(err => {
              self.$swal({
                type: "error",
                title: "Error",
                text: "Ocurrió un error al guardar las Carta Porte",
                footer: "",
              });
              self.cargar();
              self.$root.$dialogLoader.hide();
              return;
            });
        } else {
          self.$swal({
            type: "error",
            title: "Error",
            text: "No se genero ninguna Carta Porte",
            footer: "",
          });
          self.$root.$dialogLoader.hide();
          return;
        }
      } catch (e) {
        self.$swal({
          type: "error",
          title: "Error",
          text: "No se genero ninguna Carta Porte" + e,
          footer: "",
        });
        this.$root.$dialogLoader.hide();
        return;
      }

    },
    ExcelDateToJSDate: function(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      return date_info.toISOString()
    },
    ExcelTimeToJSDate: function(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var fractional_day = serial - Math.floor(serial) + 0.0000001;

       var total_seconds = Math.floor(86400 * fractional_day);

       var seconds = total_seconds % 60;

       total_seconds -= seconds;

       var hours = String(Math.floor(total_seconds / (60 * 60)));
       var minutes = String(Math.floor(total_seconds / 60) % 60);

       if (hours.length == 1) {
         hours = "0"+hours;
       }

       if (minutes.length == 1) {
         minutes = "0"+minutes;
       }
       return hours + ":" + minutes + ":" + "00Z";

    },

    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (isLt2M) {
        return true;
      }
      this.$swal({
        type: "warning",
        title: "¡Operación no Permitida!",
        text: "El archivo no debe ser mayor a 2MB.",
        footer: ""
      });
      return false;
    },
  },
};
</script>
